export const darkTheme = true;
export const linechartColors = ['#5469D4', '#A3ACB9'];
export const linechartColorsNudgeLite = [
  '#007aca',
  '#9d6dd7',
  '#25c1be',
  '#34af41',
];
export const piechartColors = [
  '#E1FFCA',
  '#CAECFF',
  '#5E4FFF',
  '#C8C3FF',
  '#4DA18C',
  '#0099c6',
  '#dd4477',
  '#66aa00',
  '#b82e2e',
];
export const neutralColors = [
  '#A8A8A8',
  '#A9A9A9',
  '#B0B0B0',
  '#B8B8B8',
  '#BEBEBE',
  '#C0C0C0',
  '#C8C8C8',
  '#D0D0D0',
  '#D3D3D3',
];

// when we use pagetype as a tag this function will return the color of the tag
export const getPagetypeTagsColors = (pagetype: string) => {
  if (pagetype === undefined || pagetype === null || pagetype === '') {
    return {
      page: 'other',
      color: '',
      cssClass: '',
      chartColor: '',
    };
  }
  let obj = [
    {
      page: 'homepage',
      color: '#e28888',
      cssClass: 'pagetype_tag',
      chartColor: '#e28888',
    },
    {
      page: 'productlist',
      color: '#97e6bf',
      cssClass: 'pagetype_tag',
      chartColor: '#97e6bf',
    },
    {
      page: 'productpage',
      color: '#ffd289',
      cssClass: 'pagetype_tag',
      chartColor: '#ffd289',
    },
    {
      page: 'cart',
      color: '#91bcdd',
      cssClass: 'pagetype_tag',
      chartColor: '#91bcdd',
    },
    {
      page: 'myaccount',
      color: '#f3997e',
      cssClass: 'pagetype_tag',
      chartColor: '#f3997e',
    },
    {
      page: 'orderconfirmation',
      color: '#c786b7',
      cssClass: 'pagetype_tag',
      chartColor: '#c786b7',
    },
    {
      page: 'deliveryaddress',
      color: '#7cc4c7',
      cssClass: 'pagetype_tag',
      chartColor: '#7cc4c7',
    },
    {
      page: 'other',
      color: '#bababa',
      cssClass: 'pagetype_tag',
      chartColor: '#bababa',
    },
  ];
  let returnObj = obj.find(
    (o) => o.page === pagetype.toLowerCase().replace(/ /g, ''),
  );
  // if (returnObj === undefined) {
  return {
    page: 'other',
    color: '#dddcdc',
    cssClass: 'pagetype_tag',
    chartColor: '#bababa',
  };
  // }
  // return returnObj;
};

export const videoExplanationSrc: any = {
  '/master-preview': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Nudge - Overview.mp4',
      label: 'Overview',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Nudge - Detailed.mp4',
      label: 'Detailed',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Nudge - Longitudinal.mp4',
      label: 'Longitudinal',
    },
    3: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Nudge - Longitudinal Detailed.mp4',
      label: 'Longitudinal Detailed',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Nudge/One Pager/Nudge One-Pager.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Nudge_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Nudge Demo.mp4',
  },
  '/diagnostic': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Diagnostic Overview.mp4',
      label: 'Overview',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Diagnostic Error Detail.mp4',
      label: 'Error Detail',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Diagnostic/One Pager/Diagnostic One-Pager.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Diagnostic_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Diagnostic Demo.mp4',
  },
  '/recording': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/User Insights.mp4',
      label: 'User Insights',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/User Insights/One Pager/User Insights One-Pager.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/User_Insights_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/User Insights Demo.mp4',
  },
  '/merchandising': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Merchandise Overview.mp4',
      label: 'Overview',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Merchandise - Products.mp4',
      label: 'Products',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Merchandise - Categories .mp4',
      label: 'Categories',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Merchandise/One Pager/Merchandise One-Pager_.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Merchandise_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Merchandise Demo.mp4',
  },
  '/agents': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Agents Overview.mp4',
      label: 'Overview',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Agents/One Pager/Agents One-Pager.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Agents_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Agents Demo.mp4',
  },
  '/signals': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Signals Overview.mp4',
      label: 'Overview',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Signals - Settings.mp4',
      label: 'Settings',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/Signals - AI Lab.mp4',
      label: 'AI Lab',
    },
    onePager:
      'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Signals/One Pager/Signals One Pager.pdf',
    caseStudy:
      'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Signals_Case_Study.pdf',
    demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Signals Demo.mp4',
  },
  '/seo/getting-started': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/1. Organic - Getting Started.mp4',
      label: 'Getting Started',
    },
  },
  '/seo/ai-analysis': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/2. Organic - AI Audit - Overview.mp4',
      label: 'Overview',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/3. Organic - AI Audit - Detailed.mp4',
      label: 'Detailed',
    },
  },
  '/seo/content': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/4. Organic - Content - Pages.mp4',
      label: 'Pages',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/5. Organic - Content - Drafts.mp4',
      label: 'Drafts',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/6. Organic- Content - Suggestions.mp4',
      label: 'Suggestions',
    },
    3: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/7. Organic - Content - Keyword Pipeline.mp4',
      label: 'Keyword Pipeline',
    },
    4: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/8. Organic - Content - AI Writing Settings.mp4',
      label: 'AI Writing Settings',
    },
  },
  '/seo/positions': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/9. Organic - Rank Tracker.mp4',
      label: 'Rank Tracker',
    },
  },
  '/seo/backlinks': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/10. Organic - Backlinks - AI Profile.mp4',
      label: 'AI Profile',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/11. Organic - Backlink - Prediction.mp4',
      label: 'Prediction',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/12. Organic - Backlink - Analysis.mp4',
      label: 'Analysis',
    },
  },
  '/seo/keywords': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/13. Organic - Keyword - Your Keywords.mp4',
      label: 'Your Keywords',
    },
    1: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/14. Organic - Keyword - Explorer.mp4',
      label: 'Explorer',
    },
    2: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/15. Organic - Keyword - Clustering.mp4',
      label: 'Clustering',
    },
  },
  '/seo/competitors': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/16. Organic - Competitors.mp4',
      label: 'Competitors',
    },
  },
  '/seo/integrations': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/17. Organic - Integrations.mp4',
      label: 'Integrations',
    },
  },
  '/seo/projects': {
    0: {
      src: 'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/dashboard_explanations/18. Organic - Integrations.mp4',
      label: 'Projects',
    },
  },
};

export const organicPDFLink: any = {
  onePager:
    'https://cdn.behamics.com/clients-screenshots/behamicsWeb/onboarding-cs-sales/Organic/One Pager/Organic One-Pager.pdf',
  caseStudy:
    'https://behamicsfront.blob.core.windows.net/clients-screenshots/behamicsWeb/onboarding-cs-sales/case_studies/Organic_Case_Study.pdf',
  demo: 'https://cdn.behamics.com/clients-screenshots/behamicsWeb/dashboard_explanations/Organic Demo.mp4',
};

export const timezoneList: any = [
  { name: 'Etc/GMT+12', offset: -12 },
  { name: 'Pacific/Midway', offset: -11 },
  { name: 'Pacific/Johnston', offset: -10 },
  { name: 'Pacific/Marquesas', offset: -9 },
  { name: 'US/Alaska', offset: -8 },
  { name: 'America/Los_Angeles', offset: -7 },
  { name: 'US/Mountain', offset: -6 },
  { name: 'America/Chicago', offset: -5 },
  { name: 'America/New_York', offset: -4 },
  { name: 'Canada/Atlantic', offset: -3 },
  { name: 'Atlantic/South_Georgia', offset: -2 },
  { name: 'Etc/GMT', offset: 0 },
  { name: 'Europe/London', offset: 1 },
  { name: 'Europe/Berlin', offset: 2 },
  { name: 'Europe/Kyiv', offset: 3 },
  { name: 'Asia/Dubai', offset: 4 },
  { name: 'Asia/Kabul', offset: 4.5 },
  { name: 'Indian/Maldives', offset: 5 },
  { name: 'Asia/Almaty', offset: 6 },
  { name: 'Asia/Bangkok', offset: 7 },
  { name: 'Asia/Hong_Kong', offset: 8 },
  { name: 'Asia/Tokyo', offset: 9 },
  { name: 'Australia/Brisbane', offset: 10 },
  { name: 'Australia/Adelaide', offset: 10.5 },
  { name: 'Australia/Lord_Howe', offset: 11 },
  { name: 'Asia/Kamchatka', offset: 12 },
  { name: 'Pacific/Apia', offset: 13 },
];
